export const meta = {
  appAlias: 'accessibility',
  appName: 'Accessibility'
};
